function generateUrlParamsFromArray(arr, key, skipValue) {
    let paramsString = "";
    arr === null || arr === void 0 ? void 0 : arr.forEach((value, index) => {
        if (!(skipValue === null || skipValue === void 0 ? void 0 : skipValue.includes(value)))
            paramsString += `${index ? "&" : ""}${key}=${value}`;
    });
    return paramsString;
}

export { generateUrlParamsFromArray };
//# sourceMappingURL=generateUrlParamsFromArray.js.map
